import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/works',
    element: <PortfolioPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
